import React from 'react';

import { Flex, Heading } from '@rover/kibble/core';
import RoverBottomSheet from '@rover/kibble/official-patterns/BottomSheet';

export type Props = {
  isOpen: boolean;
  isFullHeight?: boolean;
  onRequestClose: (payload?: unknown) => void;
  style?: ReactModal.Styles;
  headerId?: string;
  headerText?: string;
};

const BottomSheet: React.FC<{
  isOpen: boolean;
  onRequestClose: (payload?: unknown) => void;
  children: React.ReactNode;
  headerText?: string;
}> = ({ children, isOpen, onRequestClose, headerText }): JSX.Element | null => {
  const headerId = React.useId();

  return isOpen ? (
    <RoverBottomSheet
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overflowY="auto"
      isDismissible={false}
      headerId={headerText ? headerId : undefined}
      HeaderComponent={
        headerText ? (
          <Heading id={headerId} size="300" m="0x">
            {headerText}
          </Heading>
        ) : undefined
      }
    >
      <Flex width="100%" flexDirection="column" alignItems="center">
        {children}
      </Flex>
    </RoverBottomSheet>
  ) : null;
};

export default BottomSheet;
